import { Common } from '@stockbit/ui';
import { useRef } from 'react';
import alertMessage from 'global/AlertMessage';
import ERROR_MESSAGE from 'constants/errorMessage';
import If from 'global/Common/If';
import { FooterContainer, FooterIcon } from './styled';
import { ALLOWED_DOC_EXT, MAX_FILE_SIZE, MAX_FILE_SIZE_MB, MAX_IMAGE_SIZE, MAX_NOTES_DOCUMENTS_COUNT, MAX_NOTES_IMAGES_COUNT, MAX_NOTES_LENGTH } from '../constants';
import { FileType, ImageType, SavedStateType } from '../types';
import { NoteSkeletonCounter } from '../styled';

const { Text, Flex } = Common;

interface FooterProps {
  length: number;
  documents: FileType[];
  images: ImageType[];
  isLoading: boolean;
  savedState: SavedStateType;
  onSetImages: (images: ImageType[]) => void;
  onSetDocuments: (images: FileType[]) => void;
}

const Footer = ({
  length,
  documents,
  images,
  isLoading,
  savedState,
  onSetImages,
  onSetDocuments,
}: FooterProps) => {
  const pictureRef = useRef(null);
  const documentRef = useRef(null);

  // NOTE : Uncomment if product decided to allow usage of upload picture/document

  // const openPictureAttachment = () => {
  //   if (images.length <= MAX_NOTES_IMAGES_COUNT) {
  //     pictureRef.current.click();
  //   } else {
  //     alertMessage({
  //       content: `Max Allowed Upload Images is ${MAX_NOTES_IMAGES_COUNT} Images`,
  //       alertType: 'plain-default',
  //       messageType: 'error',
  //     });
  //   }
  // };

  // const openDocumentAttachment = () => {
  //   documentRef.current.click();
  // };

  // const processImages = async (imageFiles) =>
  //   Promise.all(
  //     imageFiles.map(
  //       async (imageFile) =>
  //         new Promise((resolve) => {
  //           const reader = new FileReader();
  //           reader.readAsArrayBuffer(imageFile);

  //           reader.onloadend = async (e) => {
  //             const imageType = imageFile.type;
  //             if (imageFile.size > MAX_IMAGE_SIZE) {
  //               resolve(false);
  //             }
  //             const imagePreviewUrl = URL.createObjectURL(imageFile);

  //             const data: ImageType = {
  //               preview: imagePreviewUrl,
  //               isNew: true,
  //             };

  //             if (imageType === 'image/jpeg' || imageType === 'image/jpg') {
  //               // in some case some image form not have
  //               // format that can be deleted exif, so we try catch this block
  //               // to prevent user cannot upload the image
  //               try {
  //                 // @ts-ignore
  //                 const deletedExif = deleteImageExif(
  //                   e.target.result,
  //                   imageType,
  //                 );
  //                 data.file = deletedExif;
  //               } catch (err) {
  //                 data.file = imageFile;
  //               }
  //             } else {
  //               data.file = imageFile;
  //             }
  //             resolve(data);
  //           };
  //         }),
  //     ),
  //   );

  // const handleChangePicture = async (e) => {
  //   e.preventDefault();
  //   const selectedFiles = e.target.files;
  //   const imageFiles = Array.from(selectedFiles);
  //   const processedImages = await processImages(imageFiles);
  //   const validImages = processedImages.filter((image) => image);

  //   const listImage = [...images, ...validImages];

  //   // prevent upload image more than 10
  //   const newListImage = listImage.length > MAX_NOTES_IMAGES_COUNT
  //     ? listImage.slice(0, MAX_NOTES_IMAGES_COUNT)
  //     : listImage;

  //   onSetImages(newListImage);

  //   // eslint-disable-next-line no-param-reassign
  //   e.target.value = null;
  // };

  // const handleChangeDocument = (e) => {
  //   e.preventDefault();
  //   const documentFiles = [...documents];

  //   if (
  //     e.target.files.length + documents.length > MAX_NOTES_DOCUMENTS_COUNT
  //   ) {
  //     return alertMessage({
  //       content: ERROR_MESSAGE.MAX_UPLOAD_FILES,
  //       alertType: 'default',
  //       messageType: 'error',
  //       hasCloseIcon: false,
  //     });
  //   }

  //   // validate documents
  //   Array.from(e.target.files).forEach((fileTarget: any) => {
  //     if (fileTarget.type.match('image.*')) {
  //       alertMessage({
  //         content: ERROR_MESSAGE.DOCUMENT_IMAGE_NOT_ALLOWED,
  //         alertType: 'default',
  //         messageType: 'error',
  //         hasCloseIcon: false,
  //       });
  //       return false;
  //     }

  //     if (fileTarget.size > MAX_FILE_SIZE) {
  //       alertMessage({
  //         content: `File too large. The maximum size is ${MAX_FILE_SIZE_MB}MB`,
  //         alertType: 'plain-default',
  //         messageType: 'error',
  //         hasCloseIcon: false,
  //       });
  //       return false;
  //     }

  //     const pdfPreviewUrl = URL.createObjectURL(fileTarget);

  //     documentFiles.push({
  //       preview: pdfPreviewUrl,
  //       file: fileTarget,
  //       isNew: true,
  //     });
  //   });

  //   if (documentFiles.length > 0 && documentFiles.length <= MAX_NOTES_DOCUMENTS_COUNT) {
  //     onSetDocuments(documentFiles);
  //   }

  //   // reset input file
  //   // eslint-disable-next-line no-param-reassign
  //   e.target.value = null;
  // };

  return (
    <FooterContainer>
      <div>
        <If condition={isLoading}>
          <NoteSkeletonCounter />
          <If.Else>
            <Text color="#B5B5B5" size="13px">
              {length}/{MAX_NOTES_LENGTH}
            </Text>
          </If.Else>
        </If>
      </div>
      <Flex>
        <Text color="#B5B5B5" size="13px">
          {savedState}
        </Text>
        {/* <FooterIcon
          onClick={openPictureAttachment}
          title="Image"
          src="/icon/compose-image.svg"
          alt="compose-image"
        />
        <FooterIcon
          onClick={openDocumentAttachment}
          title="Attachment"
          src="/icon/compose-attach.svg"
          alt="compose-attachment"
        />
        <input
          type="file"
          ref={pictureRef}
          style={{ display: 'none' }}
          accept="image/*"
          onChange={handleChangePicture}
          multiple
        />
        <input
          type="file"
          ref={documentRef}
          style={{ display: 'none' }}
          accept={ALLOWED_DOC_EXT.join(',')}
          onChange={handleChangeDocument}
          multiple
        /> */}
      </Flex>
    </FooterContainer>
  );
};

export default Footer;
